
export const buildHowToPlayProps = (block, state, authState) => {

  const props = block?.props ?? {};

  return {
    id: block?.id,
    type: block?.type,
    props: {
      title: props.title ?? null,
      leftCard: props.leftCard ? {
        ...props.leftCard,
        src: props.leftCard.src ? { he: props.leftCard.src.he ?? '', ar: props.leftCard.src.ar ?? '' } : null,
      } : null,
      rightText: props.rightText ?? null,
    },
    };
  };
